import './css/index.scss';
import React, { useState } from 'react';

function TableInput({
  wrapperClassName = '',
  className = '',

  innerRef,
  error,
  withLeftIcon = true,
  isLarge,
  ...p
}) {
  return (
    <div className={`table_input_div ${wrapperClassName}`}>
      {isLarge ? (
        <textarea
          ref={innerRef}
          className={`input ${error ? 'error_input' : ''} ${className}`}
          onWheel={(e) => e.currentTarget.blur()}
          {...p}
        />
      ) : (
        <input
          ref={innerRef}
          className={`input ${error ? 'error_input' : ''} ${className}`}
          onWheel={(e) => e.currentTarget.blur()}
          {...p}
        />
      )}
    </div>
  );
}

export default TableInput;
